import preloaded from '~/preloaded';
import settings from '~/settings';

import type { INation, IVehicleType } from '~/types/preloaded';

const encyclopedia = preloaded.encyclopedia || {};

const getNationData = (nationName: INation) => {
  return encyclopedia.nations?.[nationName] || null;
};

const getShipTypeData = (shipType: IVehicleType) => {
  return encyclopedia.vehiclesTypes?.[shipType] || null;
};

export const getNationUrl = (nationName: INation, size?: string) => {
  const nationData = getNationData(nationName);
  let iconUrl = '';

  if (nationData) {
    iconUrl = !size
      ? `${settings.mediaPath}${nationData.icons.default}`
      : `${settings.mediaPath}${nationData.icons[size]}`;
  }
  return iconUrl;
};

export const getShipTypes = () => {
  const shipTypes = Object.entries(encyclopedia.vehiclesTypes).map(([name, vehicle]) => {
    return { ...vehicle, name };
  });
  shipTypes.sort((a, b) => (a['order'] - b['order'] > 0 ? 1 : -1));
  return shipTypes;
};

export const getLocalizationShipTypeName = (shipType: IVehicleType) => {
  const shipTypeData = getShipTypeData(shipType);

  return (shipTypeData && shipTypeData.mark) || '';
};

export const getShipTypeUrl = (shipType: IVehicleType, isPremium: boolean, isSpecial: boolean) => {
  const shipTypeData = getShipTypeData(shipType);
  if (!shipTypeData) {
    return '';
  }

  const iconUrls = shipTypeData.icons;
  const mediaPath = settings.mediaPath;
  let icon = iconUrls.default;

  if (isPremium) {
    icon = iconUrls.premium;
  }

  if (isSpecial) {
    icon = iconUrls.special;
  }

  return `${mediaPath}${icon}`;
};

type NationShipGlossKey = 'name' | IVehicleType;
type NationShipGloss = Record<NationShipGlossKey, string | null>;
type NationsShipsTextsMap = Partial<Record<INation, NationShipGloss>>;

const buildNationsShipsTextsMap = (): NationsShipsTextsMap => {
  const nations = encyclopedia?.nations;
  const vehicleTypes = encyclopedia?.vehiclesTypes;

  if (!nations) {
    return {};
  }

  const data: NationsShipsTextsMap = Object.fromEntries(
    Object.entries(nations).map(([nation, nationInfo]) => {
      return [
        nation as INation,
        {
          name: nationInfo?.mark ?? null,
        } as NationShipGloss,
      ];
    }),
  );

  if (!vehicleTypes) {
    return data;
  }

  for (const [vehicleType, vehicleTypeInfo] of Object.entries(vehicleTypes)) {
    const label = vehicleTypeInfo?.mark ?? null;

    for (const nation of Object.keys(data) as INation[]) {
      data[nation] = {
        ...data[nation]!,
        [vehicleType as IVehicleType]: label,
      };
    }
  }

  return data;
};

export const NATIONS_SHIPS_TEXTS_MAP = buildNationsShipsTextsMap();
